import React from "react";
import DashboardListPageContainer from "./DashboardListPageContainer";

export class DashboardListPortalClientePage extends React.Component {
  render() {
    return <DashboardListPageContainer {...this.props} />;
  }
}
